import { useId } from 'react';
import type { InputHTMLAttributes, ReactNode } from 'react';
import './ui.css';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  hint?: string;
  /** Decorative leading icon rendered inside the field (the label stays the accessible name). */
  icon?: ReactNode;
}

export function Input({ label, error, hint, icon, id, className = '', ...rest }: InputProps) {
  const autoId = useId();
  const inputId = id ?? autoId;
  const describedBy = error ? `${inputId}-error` : hint ? `${inputId}-hint` : undefined;

  return (
    <div className={`ui-field ${className}`}>
      <label className="ui-label" htmlFor={inputId}>
        {label}
      </label>
      <div className="ui-input-wrap">
        {icon ? (
          <span className="ui-input-icon" aria-hidden="true">
            {icon}
          </span>
        ) : null}
        <input
          id={inputId}
          className={`ui-input ${icon ? 'ui-input-iconed' : ''} ${error ? 'ui-input-error' : ''}`}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy}
          {...rest}
        />
      </div>
      {error ? (
        <p id={`${inputId}-error`} className="ui-field-error" role="alert">
          {error}
        </p>
      ) : hint ? (
        <p id={`${inputId}-hint`} className="ui-field-hint">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
